import { useNavigate } from 'react-router-dom';
import { HealthTooltip } from './HealthTooltip';
import {formatDate, U} from '@lib/utils';
import {CachedHealthCheckResult, Failures, Property} from '@features/home/types';
import {HealthCheckStatus, HealthCheckType} from "@features/home-health/types";
import moment from "moment";
import config from "@lib/config";

interface Props {
  home: Property,
}

const HomeStatusColumn = ({ home }: Props) => {
  const navigate = useNavigate();
  const healthChecks = home.health_summary?.health_checks || {} as Record<HealthCheckType, CachedHealthCheckResult>;;
  const lastGatewayUpdate = home.health_summary?.gateway_last_update;
  const failures = (home.event_summary?.failures || {}) as Failures;

  const successful: HealthCheckStatus = {};
  const failed: HealthCheckStatus = {};
  const unavailable: string[] = [];

  // Categorize health checks
  Object.entries<CachedHealthCheckResult>(healthChecks)
    .filter(([checkType]) => config.OBSERVED_HEALTHCHECKS.includes(checkType as HealthCheckType))
    .forEach(([checkType, check]) => {
      const timestamp = formatDate(check.cached_date);
      const isStale = moment().diff(timestamp, 'days') > 7;

      if (isStale || check.result.unavailable) {
        unavailable.push(checkType);
      } else if (check.result.unhealthy) {
        failed[checkType] = timestamp;
      } else {
        successful[checkType] = timestamp;
      }
    });

  const handleClick = () => navigate(`/homes/${U(home.property_id)}/health`);

  const gatewayTimestamp = lastGatewayUpdate ? formatDate(lastGatewayUpdate) : null;

  return (
    <HealthTooltip
      gateway={gatewayTimestamp}
      successful={successful}
      failed={failed}
      unavailable={unavailable}
      failureEvents={Object.keys(failures).length > 0 ? failures : undefined}
      onClick={handleClick}
    />
  );
};

export default HomeStatusColumn;
